module.exports = __webpack_public_path__ + "img/background.ffb6ffcb.png";